import type { ThemeColors } from '@/domain/models/theme.js';
import type { HttpClient } from '@/domain/protocols/http-client.js';
import type { DefaultThemeResult, ThemeRepository } from '@/domain/repositories/theme-repository.js';

export class ThemeRepositoryImpl implements ThemeRepository {
    constructor(private readonly httpClient: HttpClient) {}

    public async getDefaultTheme(): Promise<DefaultThemeResult> {
        const response = await this.httpClient.request<{ colors: ThemeColors | null }>({ url: '/api/theme/default', method: 'GET' });
        return { colors: response.body.colors };
    }

    public async updateDefaultTheme(colors: ThemeColors): Promise<{ colors: ThemeColors }> {
        const response = await this.httpClient.request<{ colors: ThemeColors }>({ url: '/api/theme/default', method: 'PUT', body: { colors } });
        return { colors: response.body.colors };
    }
}
